function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var RETRY_DELAY_MS = 1000;
var MAX_ATTEMPTS = 3;
var createStorageKey = function(lazyComponent) {
    return "vch.retry-lazy-".concat(globalThis.btoa(lazyComponent.toString()));
};
var hasPageBeenRefreshed = function(storageKey) {
    var _globalThis_sessionStorage_getItem;
    return JSON.parse((_globalThis_sessionStorage_getItem = globalThis.sessionStorage.getItem(storageKey)) !== null && _globalThis_sessionStorage_getItem !== void 0 ? _globalThis_sessionStorage_getItem : "false");
};
var handleFinalAttempt = function(lazyComponent, error) {
    var storageKey = createStorageKey(lazyComponent);
    if (!hasPageBeenRefreshed(storageKey)) {
        globalThis.sessionStorage.setItem(storageKey, "true");
        globalThis.location.reload();
        return {
            default: function() {
                return null;
            }
        };
    }
    throw _instanceof(error, Error) ? error : new Error(String(error));
};
var delay = function(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
};
export var componentLoader = function(lazyComponent) {
    var attemptsLeft = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : MAX_ATTEMPTS;
    return _async_to_generator(function() {
        var error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        4
                    ]);
                    return [
                        4,
                        lazyComponent()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        4,
                        delay(RETRY_DELAY_MS)
                    ];
                case 3:
                    _state.sent();
                    if (attemptsLeft <= 1) {
                        return [
                            2,
                            handleFinalAttempt(lazyComponent, error)
                        ];
                    }
                    return [
                        2,
                        componentLoader(lazyComponent, attemptsLeft - 1)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
};

//# sourceMappingURL=component-loader.js.map